/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Username_PlaceholderInputs */

const en_onboarding_username_placeholder = /** @type {(inputs: Onboarding_Username_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`username`)
};

const id_onboarding_username_placeholder = /** @type {(inputs: Onboarding_Username_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`namapengguna`)
};

/** @type {(inputs: Onboarding_Username_PlaceholderInputs) => LocalizedString} */
const es_onboarding_username_placeholder = en_onboarding_username_placeholder;

/** @type {(inputs: Onboarding_Username_PlaceholderInputs) => LocalizedString} */
const fr_onboarding_username_placeholder = en_onboarding_username_placeholder;

/** @type {(inputs: Onboarding_Username_PlaceholderInputs) => LocalizedString} */
const de_onboarding_username_placeholder = en_onboarding_username_placeholder;

/** @type {(inputs: Onboarding_Username_PlaceholderInputs) => LocalizedString} */
const ja_onboarding_username_placeholder = en_onboarding_username_placeholder;

/** @type {(inputs: Onboarding_Username_PlaceholderInputs) => LocalizedString} */
const zh_onboarding_username_placeholder = en_onboarding_username_placeholder;

/** @type {(inputs: Onboarding_Username_PlaceholderInputs) => LocalizedString} */
const ar_onboarding_username_placeholder = en_onboarding_username_placeholder;

/** @type {(inputs: Onboarding_Username_PlaceholderInputs) => LocalizedString} */
const it_onboarding_username_placeholder = en_onboarding_username_placeholder;

/** @type {(inputs: Onboarding_Username_PlaceholderInputs) => LocalizedString} */
const ru_onboarding_username_placeholder = en_onboarding_username_placeholder;

/** @type {(inputs: Onboarding_Username_PlaceholderInputs) => LocalizedString} */
const pt_onboarding_username_placeholder = en_onboarding_username_placeholder;

/** @type {(inputs: Onboarding_Username_PlaceholderInputs) => LocalizedString} */
const ko_onboarding_username_placeholder = en_onboarding_username_placeholder;

/**
* | output |
* | --- |
* | "username" |
*
* @param {Onboarding_Username_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const onboarding_username_placeholder = /** @type {((inputs?: Onboarding_Username_PlaceholderInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Username_PlaceholderInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_username_placeholder(inputs)
	if (locale === "es") return es_onboarding_username_placeholder(inputs)
	if (locale === "fr") return fr_onboarding_username_placeholder(inputs)
	if (locale === "de") return de_onboarding_username_placeholder(inputs)
	if (locale === "ja") return ja_onboarding_username_placeholder(inputs)
	if (locale === "zh") return zh_onboarding_username_placeholder(inputs)
	if (locale === "ar") return ar_onboarding_username_placeholder(inputs)
	if (locale === "id") return id_onboarding_username_placeholder(inputs)
	if (locale === "it") return it_onboarding_username_placeholder(inputs)
	if (locale === "ru") return ru_onboarding_username_placeholder(inputs)
	if (locale === "pt") return pt_onboarding_username_placeholder(inputs)
	return ko_onboarding_username_placeholder(inputs)
});